import { useNavigate } from "react-router-dom";
import favicon from '../assets/images/favicon.png';
import orange_and_black_new from '../assets/images/orange-and-black-new.png';

export default function KycPending() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-slate-50 py-6 flex flex-col">
            <main className="flex-1 flex flex-col">
                <div className="w-full">
                    <div className="main__inner max-w-xl mx-auto px-4">

                        {/* Centered Logo Header */}
                        <div className="flex justify-center items-center h-20 px-2 mb-6 max-md:fixed max-md:top-0 max-md:w-full max-md:bg-white/80 max-md:left-0 max-md:px-4 max-md:h-14 max-md:shadow-sm max-md:dark:bg-slate-900/80 backdrop-blur-xl z-10">
                            <a href="/" id="logo" className="flex items-center gap-3 justify-center">
                                <img
                                    id="logo__icon"
                                    src={favicon}
                                    alt="Logo Icon"
                                    className="md:w-8 hidden text-2xl max-xl:!block max-md:!hidden shrink-0 uk-animation-scale-up"
                                />
                                <img
                                    id="logo__text"
                                    src={orange_and_black_new}
                                    alt="Logo Text"
                                    className="h-12 w-auto object-contain dark:!hidden"
                                />
                                <img
                                    id="logo__text_dark"
                                    src={orange_and_black_new}
                                    alt="Logo Text Dark"
                                    className="h-12 w-auto object-contain !hidden dark:!block"
                                />
                            </a>
                        </div>

                        {/* Pending Alert Card */}
                        <div className="mt-12 bg-white rounded-2xl border border-slate-200 shadow-xl p-8 text-center">
                            
                            {/* Animated Clock / Hourglass Icon Badge */}
                            <div className="w-16 h-16 bg-amber-50 text-amber-500 rounded-full flex items-center justify-center mx-auto mb-5 border border-amber-200/60 shadow-sm">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>

                            <span className="inline-block bg-amber-100 text-amber-800 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wider mb-3">
                                Verification In Progress
                            </span>

                            <h2 className="text-2xl font-extrabold text-slate-900 mb-3">
                                Your KYC Verification is Pending
                            </h2>

                            <p className="text-slate-600 text-sm sm:text-base leading-relaxed mb-6">
                                Thank you for submitting your details. Our team is currently reviewing your documents. Once verified, full access to the application will be unlocked automatically.
                            </p>

                            <div className="p-4 bg-slate-50 rounded-xl border border-slate-200 text-slate-500 text-xs sm:text-sm mb-6 text-left space-y-2">
                                <div className="flex items-center gap-2 text-slate-700 font-medium">
                                    <span>⏱️</span> Expected turnaround time: 24 - 48 hours.
                                </div>
                                <div className="flex items-center gap-2 text-slate-700 font-medium">
                                    <span>📩</span> You will receive an update once approval is complete.
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    );
}